import React from 'react';
import moment from 'moment-timezone';
import { Client } from 'api';
import Tracker from 'tracker';
import utils from 'utils';
import LoadingIndicator from 'components/loadingIndicator';
import { SelectField } from 'components/forms';
import NewMessage from 'components/events/newMessage';
import VendorStrip from 'components/events/vendorStrip';

export default class extends React.Component {
    static contextTypes = {
        router: React.PropTypes.object,
    };

    constructor(props) {
        super(props);

        const leads = this.props.event.leads;
        let activeLead = leads[0];

        if (this.props.leadId) {
            leads.forEach(lead => {
                if (lead.id.toString() === this.props.leadId.toString()) {
                    activeLead = lead;
                }
            });
        }

        this.api = new Client();
        this.tracker = new Tracker();

        this.state = {
            event: this.props.event,
            leads: leads,
            activeLead: activeLead,
            activeType: activeLead.vendor_type,
            saving: false,
            loading: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        const leads = nextProps.event.leads;
        let activeLead = leads[0];

        if (nextProps.leadId) {
            leads.forEach(lead => {
                if (lead.id.toString() === nextProps.leadId.toString()) {
                    activeLead = lead;
                }
            });
        }

        this.setState({
            leads: leads,
            activeLead: activeLead,
            activeType: activeLead.vendor_type,
        }, () => {
            this.loadMessages();
        });
    }

    componentWillMount() {
        this.loadMessages();
    }

    loadMessages() {
        this.setState({ loading: true });

        this.api.request(`/api/events/${this.state.event.id}/leads/${this.state.activeLead.id}`, {
            success: (lead) => {
                const leads = this.state.leads;
                this.state.leads.forEach((l, i) => {
                    if (l.id === lead.id) {
                        l.unread_messages = 0;
                        leads[i] = l;
                    }
                });

                this.setState({
                    loading: false,
                    leads: leads,
                    activeLead: lead,
                }, () => {
                    const lastMessage = $('.message:last-child');
                    this.refs.messageContainer.scrollTop = lastMessage.position().top - lastMessage.height();
                });
            },
        });
    }

    handleSubmit = ({ newMessage, attachments }, finished, error) => {
        this.setState({ saving: true });

        this.api.request(`/api/events/${this.state.event.id}/leads/${this.state.activeLead.id}`, {
            method: 'POST',
            data: {
                body: newMessage,
                attachments: attachments,
            },
            success: (response) => {
                if (response.error) {
                    this.setState({ saving: false }, () => {
                        this.tracker.logMessage('Error saving new message', {
                            has_attachments: attachments.length > 0,
                            new_message: newMessage,
                            error: response.error,
                        });
                        error(response.error);
                    });
                    return;
                }

                const lead = this.state.activeLead;
                lead.options.inactive = false;
                lead.messages.push(response);

                this.setState({
                    saving: false,
                    activeLead: lead,
                }, () => {
                    this.refs.messageContainer.scrollTop = this.refs.messageContainer.scrollHeight;
                    finished();
                });
            },
            error: () => {
                this.setState({ saving: false }, () => {
                    error('An unexpected error occurred, please try again or contact us if the problem persists.');
                    this.tracker.logMessage('Error saving new message', {
                        has_attachments: attachments.length > 0,
                        new_message: newMessage,
                    });
                });
            },
        });
    };

    handleTabClicked(leadId) {
        this.context.router.push(`/events/${this.state.event.id}/messages/${leadId}`);
    }

    handleFilterByType = (option) => {
        let activeLead = null;
        const activeType = option.value;

        this.state.leads.forEach((lead) => {
            if (!activeLead && lead.vendor_type === activeType) {
                activeLead = lead;
            }
        });

        this.handleTabClicked(activeLead.id);
    };

    handleVendorRejected = (lead) => {
        const original = this.state.activeLead;
        original.options = lead.options;

        this.setState({ activeLead: original });
    };

    render() {
        const tabs = [];
        const types = [];
        const messages = this.state.activeLead.messages || [];
        const vendor = this.state.activeLead.vendor;

        let currentStamp;
        let messageStamp;

        this.state.leads.forEach((lead) => {
            if (types.findIndex(x => x === lead.vendor_type) < 0) {
                types.push(lead.vendor_type);
            }

            if (lead.vendor_type === this.state.activeType) {
                const classes = ['vendor-tab'];
                if (this.state.activeLead.id === lead.id) {
                    classes.push('active');
                } else if (lead.options.inactive) {
                    classes.push('inactive');
                }

                tabs.push(<div
                    key={`vendorTab${lead.id}`}
                    className={classes.join(' ')}
                    onClick={this.handleTabClicked.bind(this, lead.id)}
                >
                    <div className="vendor-name">{lead.vendor_name}</div>
                    {lead.unread_messages > 0 && <div className="unread-messages">{lead.unread_messages}</div>}
                </div>);
            }
        });

        return (
            <div>
                {types.length > 1 && <div className="type-filter">
                    <SelectField
                        name="type"
                        width="style"
                        onChange={this.handleFilterByType}
                        value={this.state.activeType}
                        options={types.map(type => {
                            return { label: `Filter by type: ${type}`, value: type };
                        })}
                    />
                </div>}

                <div className={tabs.length > 1 ? 'tabbed-messages' : ''}>
                    {tabs.length > 1 && <div className="message-tabs">
                        {tabs}
                    </div>}

                    <div className="messages-wrapper">
                        <VendorStrip
                            vendor={vendor}
                            lead={this.state.activeLead}
                            event={this.state.event}
                            onRejected={this.handleVendorRejected}
                        />

                        <div className="messages" ref="messageContainer">
                            {this.state.loading && <LoadingIndicator />}
                            {messages.map((message) => {
                                const output = [];
                                let body = message.body;

                                messageStamp = moment(message.sent_on).format('dddd, MMMM Do, h:mm a');
                                if (messageStamp !== currentStamp) {
                                    currentStamp = messageStamp;
                                    output.push((
                                        <div className="message-divider">{messageStamp}</div>
                                    ));
                                }

                                body = body.replace(vendor.name, "<a href=/vendor/" + vendor.slug + " target=\"_blank\" rel=\"noopener noreferrer\">" + vendor.name + "</a>");

                                output.push((
                                    <div className="message" key={`messageBody${message.id}`}>
                                        <div className="sender">
                                            {message.profile_photo.small && <img src={message.profile_photo.small} className="profile-photo" />}
                                            {message.profile_photo.initials && <div className="default-profile-photo">{message.profile_photo.initials}</div>}
                                        </div>
                                        <div className="message-body">
                                            <div className="sender-name">{message.sent_by}</div>
                                            <div dangerouslySetInnerHTML={{ __html: utils.simple_format(body) }}></div>
                                            {message.attachments.length > 0 && <div className="message-attachments">
                                                <strong>Attachments:</strong>
                                                {message.attachments.map((attachment) => {
                                                    return <a
                                                        key={`attachment${attachment.id}`}
                                                        href={attachment.url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="attachment-link"
                                                    >
                                                        {attachment.filename}
                                                    </a>;
                                                })}
                                            </div>}
                                        </div>
                                    </div>
                                ));

                                return output;
                            })}
                        </div>

                        <div className="new-message">
                            <NewMessage saving={this.state.saving} onSubmit={this.handleSubmit} submitLabel="Reply" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/events/messages.jsx